<div class="ui-page-crumbs">
  <h1>{{interface.title }}&nbsp;</h1>
  <p>{{interface.subtitle }}&nbsp;</p>
  <ui-assignments-label-builder></ui-assignments-label-builder>
</div>
